export const updateMousePosition = (x, y) => {
  return {
    type: 'UPDATE_MOUSE_POSITION',
    x,
    y
  }
}